import { feature as dcfFeature } from '@central-products/dcf-flow';
import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';
import { ObPageTypes } from '@dcf/integration';
import { MethodsSelection } from '@central-products/interface-dcf-flow';
import { getDeviceType } from '../../utils';

import './styles.scss';

function openDeposit(next, bootstrapperFeatures) {
  const mapNextToPayMthd = {
    [MethodsSelection.PAYPAL]: MethodsSelection.PAYPAL,
    [ObPageTypes.ObDBCashier]: 'CC',
  };

  const params = !mapNextToPayMthd[next]
    ? {}
    : {
        // eslint-disable-next-line camelcase
        pay_mthd: mapNextToPayMthd[next],
      };

  bootstrapperFeatures['account-actions'].execute({
    eventId: 'event.obDeposit.requested',
    context: { params },
  });
}

export const dcfPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    const { registrationCardCreatorUrl, tdsTermUrl, tdsTermUrlV2, loadingBundleTimeout, source, enableDCFCookie } =
      params;

    if (enableDCFCookie && getDeviceType() !== 'desktop') {
      document.cookie = 'dcf_option=TRUE';
    }

    addBootstrapperFeature(dcfFeature, {
      registrationCardCreatorUrl,
      tdsTermUrl,
      tdsTermUrlV2,
      loadingBundleTimeout,
      source,
    });
  },
  postBootstrap({ bootstrapperFeatures }) {
    bootstrapperFeatures['account-actions'].onActionRequested(({ actionId }) => {
      if (actionId === ACCOUNT_ACTION_IDS.DCF_START) {
        bootstrapperFeatures['decouple-card-flow'].start();
      }
    });

    bootstrapperFeatures['decouple-card-flow'].onStateChanged(({ next }) => {
      if (next) {
        openDeposit(next, bootstrapperFeatures);
        bootstrapperFeatures['decouple-card-flow'].cancel();
      }
    });
  },
};
